import { createPortal } from "react-dom";
import { EditorView } from "prosemirror-view";
import { CreateComponentHtml, GetObjectFromHtml } from "../common/utilities";
import { GetParentNode, ComponentMode } from "../../../../common/RichTextEditorTools";
import { Button } from "@progress/kendo-react-buttons";
import { ResourceFileComponentDialog } from "./ResourceFileComponentDialog";

export const resourceFileClassName = "resource-files";

export class ResourceFileComponent {
  name?: string;
  container?: string;
  extension?: string;
  contentId?: string;
  versionId?: string;

  constructor(name?: string, container?: string, extension?: string, contentId?: string, versionId?: string) {
    this.name = name;
    this.container = container;
    this.extension = extension;
    this.contentId = contentId;
    this.versionId = versionId;
  }
}

// Create component
export const GetResourceFileComponentFromHTML = (html: string): ResourceFileComponent[] => {
  return GetObjectFromHtml(html);
};

// Create HTML
export const GetHtmlFromResourceFileComponent = async (resourceFileComponents: ResourceFileComponent[]) => {
  const html = `<div>[Resursfiler]</div>${resourceFileComponents.map((c) => `<div>${c.name || "No Name"}</div>`).join("")}`;
  return CreateComponentHtml(resourceFileClassName, resourceFileComponents, html);
};

// Tool Button
export const EditNodeToolResourceFileComponent = (settings: any) => (props: any) => {
  // console.log(settings.learningObjectId);

  // view kommer från förälderns state, så borde inte behövas ytterligare en state variable här
  const view: EditorView = props.view;
  const viewStateSchema = view.state.schema;
  const mode = ComponentMode(view, resourceFileClassName);

  // Ser ingen mening med detta, om view ändras i föräldern så kommer denna komponent att renderas om
  //   useEffect(() => {
  //     if (view) {
  //       setEditorView(view);
  //       const schema = view.state.schema;
  //       setEditorSchema(schema);
  //     }
  //   }, [view]);

  const handleSubmitEditImageComponent = (props: any) => {
    const { newNode, nodeAndPos } = props;
    const state = view.state;
    const tr = state.tr.replaceWith(nodeAndPos.pos, nodeAndPos.pos + nodeAndPos.node.nodeSize, newNode);

    // Måste vi inte clona view och anropa setView?
    view.dispatch(tr);
    settings.setEditResourceFileComponent(null);
  };

  const handleCancelEditImageComponent = () => {
    settings.setEditResourceFileComponent(null);
  };

  return (
    <>
      <Button
        onClick={() => {
          const state = view.state;
          const tr = state.tr;
          const nodeAndPos = GetParentNode(
            tr.doc,
            tr.selection.from,
            tr.selection.to,
            "str-component-" + resourceFileClassName,
            false
          );
          if (nodeAndPos) {
            settings.setEditResourceFileComponent({ nodeAndPos });
          }
        }}
        togglable={true}
        onMouseDown={(e) => e.preventDefault()}
        onPointerDown={(e) => e.preventDefault()}
        title={mode === 1 ? "Ändra dokument" : "Infoga dokument"}
        icon="doc"
        selected={mode === 1}
        disabled={mode === -1}
      />
      {settings.editResourceFileComponent &&
        createPortal(
          <ResourceFileComponentDialog
            {...settings.editResourceFileComponent}
            learningObjectId={settings.learningObjectId}
            editorSchema={viewStateSchema}
            onSubmit={handleSubmitEditImageComponent}
            onCancel={handleCancelEditImageComponent}
          />,
          document.body
        )}
    </>
  );
};
